export default {"src":"/_next/static/media/0x833589fcd6edb6e08f4c7c32d4f71b54bda02913.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};